'use strict';

angular.module('searchModule')

.controller('SearchBoxWithSolrController', ['$scope', '$q', '$location', '$state', '$stateParams', 'searchService', 'searchV2Service', function ($scope, $q, $location, $state, $stateParams, searchService, searchV2Service) {

    // Search constants
    var MIN_SEARCH_LENGTH = 1;
    var MAX_DISPLAYED_RESULTS = 10;
    var MAX_NB_FACETS_BY_COLUMN_VALUE_TO_ADD = 5;
    var MAX_DISPLAYED_RESULTS_FOR_PERSON = 6;
    var ROOT_HIERARCHICAL_FACET_INSTANCE_ID = 1000;

    // Search updates
    var searchHierarchicalFacets;
    var searchRefineFacets;
    var searchResultItems;
    var searchResultGroupsByItemTypeCode;

    $scope.searchConfiguration = {};
    $scope.searchCtx = {};
    $scope.facetConfiguration = {};
    $scope.hierarchicalFacetCtx = {};
    $scope.refineFacetCtx = {};
    $scope.searchResultsCtx = {};
    $scope.searchResultsCtx.maxDisplayedResults = MAX_DISPLAYED_RESULTS;

    reset();

    // Reset Search
    $scope.resetSearch = function () {
        $scope.searchCtx.q = '';
        reset();
        $scope.updateLocationSearch();
    }

    // Get configuration
    searchService.getConfiguration()
        .then(function (conf) {
            $scope.searchConfiguration = {
                ItemSearchActions: conf.ItemSearchActions,
                ItemSearchGroups: conf.ItemSearchGroups
            };

            $scope.facetConfiguration = {
                HierarchicalFacets: conf.HierarchicalFacets,
                RefineFacets: conf.RefineFacets
            };

            // Init contexts
            initContexts();
        });

    // Search
    var requestTimeout;

    $scope.toggleSourceSelection = function (sourceType) {

        
        $scope.searchCtx.q = '*';

        $scope.searchCtx.isSearching = true;
        $scope.searchCtx.isLoading = true;
        var params;
        if (sourceType === "") {
            params = {
                q: '*',
                n: 18, // Return Maximum 
                withHighlighting: true
            }
        }
        else {
            params = {
                q: '*',
                sourceType: sourceType,
                n: 18, // Return Maximum 
                withHighlighting: true
            }
        }


        //Use the new service to return the data
        searchV2Service
            .initializeSearch([//'CalendarMeeting'
                                 'Employee'
                               , 'Procedure'
                               , 'BusinessUnit'
                               , 'Committee'
                               , 'GlossaryTerm'
                               , 'CorporateRole'
                               , 'Control'
                               , 'Risk'
                             , 'RiskEvent'
                             , 'PlanInitiative'
                             , 'RecomActionPlan'
                             , 'Recommendation'
            ], params
               )
            .then(function (searchCtxt) {
                $scope.searchCtx.searchCtxt = searchCtxt;
            });
        $scope.updateLocationSearch();

        if (!$scope.$$phase) $scope.$apply();

    };

    $scope.search = function (q, isInit) {
        if (requestTimeout) {
            requestTimeout.resolve('New search query, current requests cancelled');
        }
        requestTimeout = $q.defer();

        if (q === "") {
            // q = "*";
        }

        if (q.length >= MIN_SEARCH_LENGTH) {
            $scope.searchCtx.isSearching = true;
            $scope.searchCtx.isLoading = true;

            //Use the new service to return the data
            searchV2Service
                .initializeSearch([//'CalendarMeeting'
                                     'Employee'
                                   , 'Procedure'
                                   , 'BusinessUnit'
                                   , 'Committee'
                                   , 'GlossaryTerm'
                                   , 'CorporateRole'
                                   , 'Control'
                                   , 'Risk'
                                 , 'RiskEvent'
                                 , 'PlanInitiative'
                                 , 'RecomActionPlan'
                                 , 'Recommendation'
                ],
                    {
                        q: q,
                        n: 18, // Return Maximum 
                        withHighlighting: true
                    })
                .then(function (searchCtxt) {
                    $scope.searchCtx.searchCtxt = searchCtxt;
                });

        }
        else {
            reset();
        }

        $scope.updateLocationSearch();

        if (!$scope.$$phase) $scope.$apply();
    };

    // Update hierarchical facet context
    $scope.updateHierarchicalFacetContext = function (instanceFacetId, forceResultsRefresh) {
        if (!searchHierarchicalFacets.length) {
            $scope.hierarchicalFacetCtx.levels = [];
            $scope.refineFacetCtx.selected = {};
            $scope.updateLocationSearch();
            return;
        }

        $scope.hierarchicalFacetCtx.hasSomeBeenSelected = true;
        if (instanceFacetId === $scope.hierarchicalFacetCtx.rootInstanceId) {
            $scope.hierarchicalFacetCtx.hasSomeBeenSelected = false;
        }

        // Search results filtered by hierarchical facets
        var resultsFilteredBySelectedHierarchicalFacet =
            _.chain(searchHierarchicalFacets)
             .filter(function (facet) {
                 // Only keep selected facet's children
                 return facet.ParentInstanceHierarchicalFacetID === instanceFacetId;
             })
             .value();

        var currentLevel = buildHierarchicalFacetLevel(instanceFacetId);
        currentLevel.results = resultsFilteredBySelectedHierarchicalFacet;
        currentLevel.resultsCount = resultsFilteredBySelectedHierarchicalFacet.length;

        var hierarchicalFacetLevelIdx = _.findIndex($scope.hierarchicalFacetCtx.levels, {
            instanceFacetId: instanceFacetId
        });

        // Current Level
        if (hierarchicalFacetLevelIdx > -1) {
            // Level found : Discard next levels and update current one
            $scope.hierarchicalFacetCtx.levels.splice(hierarchicalFacetLevelIdx + 1);
            _.assign($scope.hierarchicalFacetCtx.levels[hierarchicalFacetLevelIdx], currentLevel);
        } else {
            // Level not found: Add it
            $scope.hierarchicalFacetCtx.levels.push(currentLevel);
        }
        $scope.hierarchicalFacetCtx.currentLevel = currentLevel;

        // Update facets
        $scope.hierarchicalFacetCtx.facets =
            _.chain(currentLevel.results)
             .groupBy('InstanceHierarchicalFacetID')
             .map(function (items, instanceHierarchicalFaceId) {
                 var facetLevelConfiguration = _.find($scope.facetConfiguration.HierarchicalFacets, {
                     InstanceHierarchicalFacetID: parseInt(instanceHierarchicalFaceId, 10)
                 });

                 return _.assign({
                     Items: items,
                     ItemsCount: items.length
                 }, facetLevelConfiguration);
             })
             .value();

        if (instanceFacetId) {

            if (currentLevel.results.length === 0) {

                // End of chain => Filter by InstanceHierarchicalFacetID instead
                $scope.hierarchicalFacetCtx.currentLevel.results =
                    _.chain(searchHierarchicalFacets)
                     .filter({ InstanceHierarchicalFacetID: instanceFacetId })
                     .value();
                $scope.hierarchicalFacetCtx.currentLevel.resultsCount = $scope.hierarchicalFacetCtx.currentLevel.results.length;

                // Not in good facet chain => go back to Categories
                if ($scope.hierarchicalFacetCtx.currentLevel.resultsCount === 0) {
                    $scope.updateHierarchicalFacetContext($scope.hierarchicalFacetCtx.rootInstanceId);
                    return;
                }
            }
        }

        // If only one facet found => go inside
        if ($scope.hierarchicalFacetCtx.facets.length === 1) {
            if (hierarchicalFacetLevelIdx > -1) {
                $scope.hierarchicalFacetCtx.levels[hierarchicalFacetLevelIdx].isHidden = true;
            }

            $scope.updateHierarchicalFacetContext($scope.hierarchicalFacetCtx.facets[0].InstanceHierarchicalFacetID);
            $scope.hierarchicalFacetCtx.hasSomeBeenSelected = false;
            return;
        }

        if (instanceFacetId !== $scope.hierarchicalFacetCtx.rootInstanceId || forceResultsRefresh) {
            // Filter Results by Hierarchical Facet
            filterResultsByHierarchicalFacet($scope.hierarchicalFacetCtx.currentLevel.results);
        }

        updateRefineFacetContext($scope.hierarchicalFacetCtx.currentLevel.results);

        $scope.updateLocationSearch();
    };

    // Toggle Refine Selection
    $scope.toggleRefineFacetSelection = function (refineFacetID, columnValue) {
        var refineFacetsBySelectedID = _.find($scope.refineFacetCtx.byRefineFacetId, {
            RefineFacetID: refineFacetID
        });
        var refineFacetsByColumnValue = _.find(refineFacetsBySelectedID.RefineFacetsByColumnValue, {
            ColumnValue: columnValue
        });
        var selectedRefineFacetResults = [];
        var refineFacetResultItemIdsToDisplay = [];

        // Toggle corresponding column value
        refineFacetsByColumnValue.isSelected = !refineFacetsByColumnValue.isSelected;
        refineFacetsBySelectedID.SelectedColumnValue = columnValue;
        if (!refineFacetsByColumnValue.isSelected) {
            refineFacetsBySelectedID.SelectedColumnValue = null;
            delete $scope.refineFacetCtx.selected[refineFacetsBySelectedID.RefineFacetID];
        } else {
            $scope.refineFacetCtx.selected[refineFacetsBySelectedID.RefineFacetID] = refineFacetsByColumnValue.ColumnValue;
        }

        // Upon Person refine selection : 2014
        if (refineFacetID === 2014 && refineFacetsByColumnValue.isSelected) {
            $scope.refineFacetCtx.selectedPerson = refineFacetsByColumnValue;
        } else {
            $scope.refineFacetCtx.selectedPerson = null;
        }

        // Toggle other refine facets hidden state with the same ID
        _.forEach(refineFacetsBySelectedID.RefineFacetsByColumnValue, function (byColumnValue) {
            if (byColumnValue.ColumnValue !== refineFacetsByColumnValue.ColumnValue) {
                byColumnValue.isHidden = !byColumnValue.isHidden;
            }
        });

        // Get all the selected refine facets
        _.forEach($scope.refineFacetCtx.byRefineFacetId, function (refineFacetsById) {
            _.forEach(refineFacetsById.RefineFacetsByColumnValue, function (refineFacetsByColumnValue) {
                if (refineFacetsByColumnValue.isSelected) {
                    selectedRefineFacetResults.push(_.map(refineFacetsByColumnValue.RefineFacets, 'ResultItemID'));
                }
            })
        });

        // Get all refine facet results item ids to display
        refineFacetResultItemIdsToDisplay = _.intersection.apply(this, selectedRefineFacetResults);

        // Update the counts
        updateRefineFacetsCount(refineFacetResultItemIdsToDisplay);

        // Update Refine facets by column value counts with intersection with currently displayed
        _.forEach($scope.refineFacetCtx.byRefineFacetId, function (refineFacetsById) {
            _.forEach(refineFacetsById.RefineFacetsByColumnValue, function (refineFacetsByColumnValue) {
                var refineFacetResultItemIdsIntersection;

                if (!refineFacetsByColumnValue.isSelected) {
                    refineFacetResultItemIdsIntersection = _.intersection(
                        _.map(refineFacetsByColumnValue.RefineFacets, 'ResultItemID'),
                        refineFacetResultItemIdsToDisplay
                    );

                    // We are interested only by facets that lower the number of displayed items
                    refineFacetsByColumnValue.RefineFacetsCount = refineFacetResultItemIdsIntersection.length;
                    //if (refineFacetResultItemIdsIntersection.length < refineFacetResultItemIdsToDisplay.length) {
                    //    refineFacetsByColumnValue.RefineFacetsCount = refineFacetResultItemIdsIntersection.length;
                    //} else {
                    //    refineFacetsByColumnValue.RefineFacetsCount = 0;
                    //}

                    refineFacetsByColumnValue.isHidden = refineFacetsByColumnValue.RefineFacetsCount === 0;
                }

            })
        });

        updateHierarchicalFacetsCount(selectedRefineFacetResults, refineFacetResultItemIdsToDisplay);

        if (selectedRefineFacetResults.length === 0) {
            // Filter results by hierarchical facet only
            $scope.updateHierarchicalFacetContext($scope.hierarchicalFacetCtx.currentLevel.instanceFacetId, true);
            $scope.hierarchicalFacetCtx.hasSomeBeenSelected = false;
            $scope.refineFacetCtx.hasSomeBeenSelected = false;
        } else {
            // Filter results by selected refine facets
            filterResultsBySelectedRefineFacets(refineFacetResultItemIdsToDisplay);
            $scope.refineFacetCtx.hasSomeBeenSelected = true;
        }

        $scope.updateLocationSearch();
    };

    // Helpers

    // Update refine facet context
    function updateRefineFacetContext(resultsFilteredBySelectedHierarchicalFacet) {

    // Filter refine facet results by current Hierarchy level
        $scope.refineFacetCtx.byRefineFacetId =
            _.chain(searchRefineFacets)
             .filter(function (refineFacet) {
                 var isRefineFacetInConfigForCurrentHierarchy = _.some($scope.facetConfiguration.RefineFacets, {
                     RefineFacetID: refineFacet.RefineFacetID,
                     InstanceHierarchicalFacetID: $scope.hierarchicalFacetCtx.currentLevel.instanceFacetId
                 });

                 var isInResultsFilteredByHierarchy = _.some(resultsFilteredBySelectedHierarchicalFacet, {
                     ResultItemID: refineFacet.ResultItemID
                 });

                 isRefineFacetInConfigForCurrentHierarchy = _.some($scope.facetConfiguration.RefineFacets, {
                     RefineFacetID: refineFacet.RefineFacetID,
                     InstanceHierarchicalFacetID: $scope.hierarchicalFacetCtx.currentLevel.instanceFacetId
                 });

                 return isRefineFacetInConfigForCurrentHierarchy && isInResultsFilteredByHierarchy;
             })
             .map(function (refineFacet) {
                 var refineFacetConfig =
                      _.find($scope.facetConfiguration.RefineFacets, { RefineFacetID: refineFacet.RefineFacetID });

                 return _.assign(refineFacet, refineFacetConfig);
             })
             .groupBy(function (refineFacet) {
                 return refineFacet.RefineFacetID;
             })
             .map(function (byRefineFacetId) {
                 var refineFacetsByColumnValue =
                     _.chain(byRefineFacetId)
                      .groupBy('ColumnValue')
                      .map(function (byColumnValueFacets, columnValue) {
                          return {
                              RefineFacetID: byColumnValueFacets[0].RefineFacetID,
                              ColumnObjectID: byColumnValueFacets[0].ColumnObjectID,
                              ColumnValue: columnValue,
                              Selected: false,
                              RefineFacets: byColumnValueFacets,
                              RefineFacetsCount: byColumnValueFacets.length,
                          }
                      })
                      .sortBy('ColumnValue')
                      .value();

                 return {
                     Name: byRefineFacetId[0].Name,
                     RefineFacetID: byRefineFacetId[0].RefineFacetID,
                     ColumnObjectTemplate: byRefineFacetId[0].ColumnObjectTemplate,
                     RefineFacetsByColumnValue: refineFacetsByColumnValue,
                     DisplayedRefineFacetsByColumnValue: refineFacetsByColumnValue,
                     OrderID: byRefineFacetId[0].OrderID
                 };
             })
             .sortBy('OrderID') // Ascending
             .value();

        if (!_.size($scope.refineFacetCtx.selected)) {
            // Update the count
            updateRefineFacetsCount(_.map(resultsFilteredBySelectedHierarchicalFacet, 'ResultItemID'));
        } else {
            // Toggle all the selected
            _.forEach($scope.refineFacetCtx.byRefineFacetId, function (refineFacetsById) {
                _.forEach(refineFacetsById.RefineFacetsByColumnValue, function (refineFacetsByColumnValue) {
                    if ($scope.refineFacetCtx.selected[refineFacetsByColumnValue.RefineFacetID] ===
                            refineFacetsByColumnValue.ColumnValue) {
                        $scope.toggleRefineFacetSelection(refineFacetsById.RefineFacetID, refineFacetsByColumnValue.ColumnValue);
                    }
                })
            });
        }
    }

    // Update Hierarchical Facets count
    function updateHierarchicalFacetsCount(selectedRefineFacets, refineFacetResultItemIdsToDisplay) {
        if ($scope.hierarchicalFacetCtx.facets.length) {
            _.forEach($scope.hierarchicalFacetCtx.facets, function (hierarchicalFacet) {
                if (!selectedRefineFacets.length) {
                    hierarchicalFacet.ItemsCount = hierarchicalFacet.Items.length;
                    return;
                }

                hierarchicalFacet.ItemsCount = _.reduce(hierarchicalFacet.Items, function (total, item) {
                    if (_.indexOf(refineFacetResultItemIdsToDisplay, item.ResultItemID) > -1) {
                        return total + 1;
                    }

                    return total;
                }, 0);
            });

            $scope.hierarchicalFacetCtx.currentLevel.resultsCount =
                _.reduce($scope.hierarchicalFacetCtx.facets, function (total, facet) {
                    return total + facet.ItemsCount;
                }, 0);
        } else {
            if (!selectedRefineFacets.length) {
                $scope.hierarchicalFacetCtx.currentLevel.resultsCount = $scope.hierarchicalFacetCtx.currentLevel.results.length;
            } else {
                $scope.hierarchicalFacetCtx.currentLevel.resultsCount =
                    _.reduce($scope.hierarchicalFacetCtx.currentLevel.results, function (total, item) {
                        if (_.indexOf(refineFacetResultItemIdsToDisplay, item.ResultItemID) > -1) {
                            return total + 1;
                        }

                        return total;
                    }, 0);
            }
        }
    }

    // Update Refine facets by column value counts with intersection with currently displayed results
    function updateRefineFacetsCount(refineFacetResultItemIdsToDisplay) {
        _.forEach($scope.refineFacetCtx.byRefineFacetId, function (refineFacetsById) {
            _.forEach(refineFacetsById.RefineFacetsByColumnValue, function (refineFacetsByColumnValue) {
                var refineFacetResultItemIdsIntersection;

                refineFacetResultItemIdsIntersection = _.intersection(
                    _.map(refineFacetsByColumnValue.RefineFacets, 'ResultItemID'),
                    refineFacetResultItemIdsToDisplay
                );

                refineFacetsByColumnValue.RefineFacetsCount = refineFacetResultItemIdsIntersection.length;

                if (!refineFacetsByColumnValue.isSelected) {
                    //if (refineFacetResultItemIdsIntersection.length === refineFacetResultItemIdsToDisplay.length) {
                    //    // Refine facet doesn't refine more
                    //    refineFacetsByColumnValue.RefineFacetsCount = 0;
                    //} 
                }

                refineFacetsByColumnValue.isHidden = refineFacetsByColumnValue.RefineFacetsCount === 0;
            });
        });
    }

    // Filter results by selected refined facet
    function filterResultsBySelectedRefineFacets(refineFacetResultsToDisplay) {
        var filteredSearchResultGroupsByItemTypeCode;

        if (_.size(refineFacetResultsToDisplay) === 0) {
            filteredSearchResultGroupsByItemTypeCode = [];
        } else {
            filteredSearchResultGroupsByItemTypeCode =
               _.chain(searchResultGroupsByItemTypeCode)
                .map(function (group) {
                    var filteredItems =
                        _.chain(group.Items)
                         .filter(function (groupItem) {
                             return _.indexOf(refineFacetResultsToDisplay, groupItem.ItemID) > -1;
                         })
                         .value();

                    return {
                        ItemTypeCode: group.ItemTypeCode,
                        ItemTypeTitleEN: group.ItemTypeTitleEN,
                        Items: filteredItems,
                        ItemsCount: filteredItems.length
                    }
                })
                .reject(function (group) {
                    return group.ItemsCount === 0
                })
                .value();
        }

        updateDisplayedSearchGroups(filteredSearchResultGroupsByItemTypeCode);
    }

    // Filter results by hierarchical facet
    function filterResultsByHierarchicalFacet(resultsFilteredBySelectedHierarchicalFacet) {

        if (resultsFilteredBySelectedHierarchicalFacet.length === 0) {
            return;
        }

        var filteredSearchResultGroupsByItemTypeCode =
            _.chain(searchResultGroupsByItemTypeCode)
             .map(function (group) {
                 var filteredItems =
                     _.chain(group.Items)
                      .filter(function (groupItem) {
                          return _.some(resultsFilteredBySelectedHierarchicalFacet, { ResultItemID: groupItem.ItemID });
                      })
                      .value();

                 return {
                     ItemTypeCode: group.ItemTypeCode,
                     ItemTypeTitleEN: group.ItemTypeTitleEN,
                     Items: filteredItems,
                     ItemsCount: filteredItems.length
                 }
             })
             .reject(function (group) {
                 return group.ItemsCount === 0;
             })
             .value();

        updateDisplayedSearchGroups(filteredSearchResultGroupsByItemTypeCode);
    }

    // Update search results groups by result Type code
    function updateSearchGroupsByResultTypeCode() {
        searchResultGroupsByItemTypeCode =
            _.chain(searchResultItems)
             .groupBy('ItemTypeCode')
             .map(function (items) {
                 return {
                     ItemTypeCode: items[0].ItemTypeCode,
                     ItemTypeTitleEN: items[0].ItemTypeTitleEN,
                     Items: items
                 };
             })
             .value();

        updateDisplayedSearchGroups(searchResultGroupsByItemTypeCode);
    }

    // Update displayed search groups
    function updateDisplayedSearchGroups(groupsByItemTypeCode) {
        if (_.size(groupsByItemTypeCode) === 0) {
            $scope.searchCtx.resultsByType = [];
            return;
        }

        var maxDisplayedResultsByGroup = Math.ceil(MAX_DISPLAYED_RESULTS / _.size(groupsByItemTypeCode));

        $scope.searchCtx.resultsByType =
            _.chain(groupsByItemTypeCode)
             .map(function (group) {
                 var totalCount = group.Items.length;
                 var groupItemsNbToTake = group.ItemTypeCode === 'PSPEmployee' ?
                     MAX_DISPLAYED_RESULTS_FOR_PERSON : maxDisplayedResultsByGroup;
                 var displayedItems = _.take(group.Items, groupItemsNbToTake);

                 return {
                     ItemTypeCode: group.ItemTypeCode,
                     ItemTypeTitleEN: group.ItemTypeTitleEN,
                     DisplayedItems: displayedItems,
                     Items: group.Items,
                     ItemsCount: totalCount,
                     ShowMoreResultsCount: totalCount - displayedItems.length,
                     maxDisplayedResults: groupItemsNbToTake
                 }
             })
             .value();
    }

    // Update location search
    $scope.updateLocationSearch = function () {
        $location
            .search({
                q: $scope.searchCtx.q,
                h: _.map($scope.hierarchicalFacetCtx.levels, 'instanceFacetId'),
                r: _.map($scope.refineFacetCtx.selected, function (columnValue, refineFacetId) {
                    return refineFacetId + ',' + columnValue;
                })
            })
            .replace();
    };

    // Reset 
    function reset() {
        searchHierarchicalFacets = [];
        searchRefineFacets = [];
        searchResultItems = [];
        searchResultGroupsByItemTypeCode = [];
        $scope.searchCtx.searchCtxt = [];

        if (!$scope.searchCtx.q) { $scope.searchCtx.q = undefined; }
        $scope.searchCtx.isSearching = false;
        $scope.searchCtx.isLoading = false;
        $scope.searchCtx.resultsByType = [];

        $scope.hierarchicalFacetCtx.hasSomeBeenSelected = false;
        $scope.hierarchicalFacetCtx.levels = [];

        $scope.refineFacetCtx.hasSomeBeenSelected = false;
        $scope.refineFacetCtx.selected = {};
        $scope.refineFacetCtx.selectedPerson = null
    }

    // Init contexts
    function initContexts() {
        // Inherited constants
        $scope.hierarchicalFacetCtx.rootInstanceId = ROOT_HIERARCHICAL_FACET_INSTANCE_ID;

        // Search context
        $scope.searchCtx.q = $stateParams.q || '';

        // Hierarhical context
        var instancesHeirarchicalFacetIds = [ROOT_HIERARCHICAL_FACET_INSTANCE_ID];
        if (_.isArray($stateParams.h)) {
            _.forEach($stateParams.h, function (instanceId) {
                instancesHeirarchicalFacetIds.push(parseInt(instanceId, 10));
            })
        }
        $scope.hierarchicalFacetCtx.levels = _.map(_.uniq(instancesHeirarchicalFacetIds), buildHierarchicalFacetLevel);
        $scope.hierarchicalFacetCtx.currentLevel = _.last($scope.hierarchicalFacetCtx.levels);

        // Refine facets context
        $scope.refineFacetCtx.selected = {};

        if (_.isArray($stateParams.r)) {
            _.forEach($stateParams.r, function (rFacet) {
                var splitted = rFacet.split(','); // Format: RefineFacetID,ColumnValue;

                if (splitted.length !== 2) { return; }

                var refineFacetId = parseInt(splitted[0], 10);
                var columnValue = splitted[1];

                $scope.refineFacetCtx.selected[refineFacetId] = columnValue;
            });
        }

        $scope.search($scope.searchCtx.q, true); // isInit: true
    }

    // Build Hierarchical Facet Level
    function buildHierarchicalFacetLevel(instanceFacetId) {
        if (!instanceFacetId) { return; }

        var facetLevel = {
            instanceFacetId: instanceFacetId,
            isHidden: false
        };

        // Facet level configs
        var parentFacetLevelConfig = _.find($scope.facetConfiguration.HierarchicalFacets, function (config) {
            if (!config.ParentInstanceHierarchicalFacetID && !instanceFacetId) { return true; }

            return config.ParentInstanceHierarchicalFacetID === instanceFacetId;
        });
        var facetLevelConfig = _.find($scope.facetConfiguration.HierarchicalFacets, {
            InstanceHierarchicalFacetID: instanceFacetId
        });

        facetLevel.name = facetLevelConfig.TitleEN;
        if (instanceFacetId === $scope.hierarchicalFacetCtx.rootInstanceId) {
            facetLevel.name = parentFacetLevelConfig.Name;
        }

        facetLevel.parentInstanceId = facetLevelConfig.parentFacetLevelConfig;

        return facetLevel;
    }
}]);